Vue.component('editor', {
  delimiters: ['[[', ']]'],
  mixins: [eventHubMixin, languageMixin],
  data: () => {
    return {
      editor: null,
      editableId: null,
      display: false,
      initialContent: '',
      configs: {}
    }
  },

  computed: {
    key() {
      return `value_${this.language}`;
    }
  },

  methods: {

    close (reset) {
      this.editor.destroy();
      if (reset) {
        this.eventHub.$emit(`editable:update:${this.editableId}`, this.initialContent)
      }
      this.display = false;
    },

    getData(cb) {
      cb = cb || (() => {});
      axios({
        method: 'GET',
        url: `/api/v1/contents/${this.editableId}`,
      }).then( (response) => {
        cb(response)
      }).catch( (error) => {
        // console.log(error)
      })
    },

    save () {
      let data = {};
      data[this.key] = this.editor.getData();
      axios({
        method: 'PATCH',
        url: `/api/v1/contents/${this.editableId}`,
        headers: {
          'X-CSRFToken': window.csrfToken
        },
        data: data
      }).then( (response) => {
        this.eventHub.$emit('alerts:success', this.t('editor:info:saved', 'Content successfully saved'))
        this.close(false);
      }).catch( (error) => {
        // console.log(error)
      })
    },

    initEditor (data) {
      this.getData((response) => {
        let content = response.data[this.key];
        // fail back to en
        if (content == null) {
          content = response.data['value_en'];
        }
        this.initialContent = content;
        if (this.editor) {
          this.editor.destroy();
        }
        this.editor = CKEDITOR.replace(this.$refs.textarea, this.configs[data.config]);
        this.editor.setData( content );
        this.editor.on( 'change', () => {
          this.eventHub.$emit(`editable:update:${this.editableId}`, this.editor.getData())
        });
      });
    }
  }, 

  mounted () {
    this.configs = {
      inline: {
        language: this.language,
        uiColor: '#EEEEEE',
        toolbar: [
          { name: 'default', items: ['Bold', 'Italic', '|', 'RemoveFormat', 'Source'] }
        ],
        autoParagraph: false,
        shiftEnterMode: 2,
        enterMode: 2,
        entities: false,
      },
      block: {
        language: this.language,
        uiColor: '#EEEEEE',
        toolbar: [
          { name: 'default', items: ['Bold', 'Italic', '|', 'NumberedList', 'BulletedList', '|', 'RemoveFormat', 'Source'] }
        ],
        autoParagraph: false,
        shiftEnterMode: 2,
        enterMode: 1,
        entities: false,
      },
      text: {
        language: this.language,
        uiColor: '#EEEEEE',
        toolbar: [
          { name: 'default', items: ['RemoveFormat', 'Source'] }
        ],
        autoParagraph: false,
        shiftEnterMode: 2,
        enterMode: 2,
        entities: false,
      }
    }
    this.eventHub.$on('editor:open', (data) => {
      this.editableId = data.editableId;
      this.display = true;
      this.initEditor(data);
    })
  },
  template: `<transition name="tsn-slide-fade">
    <div class="dj-content-form" v-show="display">
        <textarea name="content" cols="30" rows="10" ref="textarea"></textarea>
        <button class="dj-content-submit" @click="save()">Valider</button>
        <button class="dj-content-close" @click="close(true)">Fermer</button>
        <div class="dj-content-info" v-pre>Do not modify content between "[[  ]]" or "{{ }}"</div>
    </div>
</transition>`
})